export default __webpack_public_path__ + "static/media/horse-in-stall-v2-flipped.afd90fc8.jpg";